import { createContext } from 'react'

export interface AppError {
  status?: number
  message: string
  path?: string
  timestamp?: string
  fieldErrors?: Record<string, string>
}

export interface ErrorContextValue {
  error: AppError | null
  reportError: (error: unknown) => void
  clearError: () => void
}

export const ErrorContext = createContext<ErrorContextValue | null>(null)
